import { Component } from 'react';
import {Control, Errors} from 'forms/rrf';
import {Col, Container, FormGroup, FormLabel, Row} from 'react-bootstrap';
import BsCheckbox from '../../../common/form/elements/bs-checkbox';

import './styles.css';

class SMSMessage extends Component {
  setSMS = () => {
    this.setState({
      sms: !this.state.sms
    });
  };

  constructor(props) {
    super(props);
    this.state = {
      sms: false,
    };
  }

  render() {
    return (
      <Container fluid className="editor">
        <Row>
          <Col md={12}>
            <FormGroup>
              <Control.checkbox
                component={BsCheckbox}
                model='.sms'
                onChange={this.setSMS}
              >
                SMS
              </Control.checkbox>
            </FormGroup>
            <FormGroup controlId="sms-body">
              <FormLabel>
                Body*
              </FormLabel>
              <Control.textarea
                className="form-control"
                model=".sms_body"
                rows="2"
              />

              <Errors
                className="errors"
                model=".sms_body"
                show={{
                  touched: true,
                  focus: false
                }}
              />
            </FormGroup>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default SMSMessage;
